module.exports = __webpack_public_path__ + "static/media/paper.b6e2ff4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprites/paper.png
// module id = 150
// module chunks = 0